<div class="row m-0 p-0 w-100">
  <div class="col-4 ps-0 pe-0">
    <table class="table table-hover">
      <thead>
        <tr>
          <th colspan="2" i18n>악곡 적성</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td i18n>큐트</td>
          <td>{{ this.getAttribute("cute") }}</td>
        </tr>
        <tr>
          <td i18n>쿨</td>
          <td>{{ this.getAttribute("cool") }}</td>
        </tr>
        <tr>
          <td i18n>포지티브</td>
          <td>{{ this.getAttribute("positive") }}</td>
        </tr>
        <tr>
          <td i18n>릴렉스</td>
          <td>{{ this.getAttribute("relax") }}</td>
        </tr>
        <tr>
          <td i18n>이모셔널</td>
          <td>{{ this.getAttribute("emotional") }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-4 ps-0 pe-0">
    <table class="table table-hover">
      <thead>
        <tr>
          <th colspan="2" i18n>퍼포먼스 적성</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td i18n>하이 페이스</td>
          <td>{{ this.getAttribute("high") }}</td>
        </tr>
        <tr>
          <td i18n>미들 페이스</td>
          <td>{{ this.getAttribute("medium") }}</td>
        </tr>
        <tr>
          <td i18n>슬로우 페이스</td>
          <td>{{ this.getAttribute("slow") }}</td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="col-4 ps-0 pe-0">
    <table class="table table-hover">
      <thead>
        <tr>
          <th colspan="2" i18n>환경 적성</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td i18n>쾌청</td>
          <td>{{ this.getAttribute("fine") }}</td>
        </tr>
        <tr>
          <td i18n>맑음</td>
          <td>{{ this.getAttribute("sunny") }}</td>
        </tr>
        <tr>
          <td i18n>흐림</td>
          <td>{{ this.getAttribute("cloudy") }}</td>
        </tr>
        <tr>
          <td i18n>비</td>
          <td>{{ this.getAttribute("rain") }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
